export const BOT_USERNAME: string = import.meta.env.VITE_BOT_USERNAME ?? 'kasbooek_bot';
export const BOT_URL = `https://t.me/${BOT_USERNAME}`;

export const ROUTES = {
  dashboard: '/',
  transactions: '/transaksi',
  settings: '/pengaturan',
  profile: '/profil',
  join: '/join/:code',
  login: '/masuk',
  authCallback: '/auth/callback',
} as const;

export const CREATE_TRANSACTION_HREF = `${ROUTES.transactions}?catat=1`;

export const QUERY_STALE_MS = 30_000;
